/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Member_ServicesInputs */

const en_wallet_card_member_services = /** @type {(inputs: Wallet_Card_Member_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Services`)
};

const fr_wallet_card_member_services = /** @type {(inputs: Wallet_Card_Member_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services aux membres`)
};

/**
* | output |
* | --- |
* | "Member Services" |
*
* @param {Wallet_Card_Member_ServicesInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_member_services = /** @type {((inputs?: Wallet_Card_Member_ServicesInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Member_ServicesInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_member_services(inputs)
	return fr_wallet_card_member_services(inputs)
});